import React, { useCallback, useEffect, useState } from "react";
import Table from "../components/Table";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../config/config";
import { toast, ToastContainer } from "react-toastify";

export default function Investment({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [investorList, setInvestorList] = useState([]);
  const [investorToDelete, setInvestorToDelete] = useState();
  const [profitRatio, setProfitRatio] = useState(0);
  const [invId, setInvId] = useState(null);
  const [branchId, setBranchId] = useState();

  const isLighMode =
    JSON.parse(
      JSON.parse(sessionStorage.getItem("aman-admin") || "")?.admin || ""
    )?.light_mode === "yes";

  const navigate = useNavigate();

  const returnTable = async (table) => {
    await setInvestorToDelete(table.map((item) => item.original.id));
  };

  const fetchInvestor = useCallback(() => {
    try {
      axios
        .get(apiKey + "/investor", {
          params: {
            branch_id: branchId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setInvestorList(res.data.result);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (err) {
      console.error(err);
    }
  }, [branchId, token]);

  const columns = [
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: lang.Investor_Name || "Investor Name",
      accessorKey: "FullName",
    },
    {
      header: lang.Identity_Number || "Identity Number",
      accessorKey: "ValidNationalID",
    },
    {
      header: lang.Balance || "Balance",
      accessorKey: "balance",
    },
    {
      header: lang["Profit Ratio %"] || "Profit Ratio %",
      accessorKey: "profit_ratio",
    },
    {
      header: lang.Mobile_Number || "Mobile Number",
      accessorKey: "MobilePhoneNo",
    },
    {
      header: lang["Is Office?"] || "Is Office?",
      accessorKey: "is_office",
      cell: (row) => (
        <CheckBox id={row.row.original.inv_id} status={row.getValue()} />
      ),
    },
    {
      header: lang.Status || "Status",
      accessorKey: "status",
      cell: (row) => (
        <p>
          {row.getValue() === 1 ? (
            <span className="badge rounded-pill bg-success">
              {lang.active || "Active"}
            </span>
          ) : (
            <span className="badge rounded-pill bg-danger">
              {lang.inactive || "In-active"}
            </span>
          )}
        </p>
      ),
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <div className="dropdown top-0 start-0">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {lang.Actions || "Actions"}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <button
                className="dropdown-item mt-0"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("profile/investor/" + row.row.original.id);
                }}
              >
                {lang.Profile || "Profile"}
              </button>
            </li>
            <li>
              <button
                className="dropdown-item mt-0"
                onClick={() => {
                  let phoneNo = row.row.original.MobilePhoneNo.toString();
                  let waNum = "+966" + phoneNo.slice(1);
                  window.open("https://wa.me/" + waNum, "_blank");
                }}
              >
                {lang.whatsapp || "WhatsApp"}
              </button>
            </li>
            <li>
              <Link
                to={`transaction/${row.row.original.id}/deposit`}
                className="dropdown-item mt-0"
              >
                {lang.Deposit || "Deposit"}
              </Link>
            </li>
            <li>
              <Link
                to={`transaction/${row.row.original.id}/withdraw`}
                className="dropdown-item mt-0"
              >
                {lang.Withdrawal || "Withdraw"}
              </Link>
            </li>
            <li>
              <button
                className="dropdown-item mt-0"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#myModal"
                onClick={() => {
                  setProfitRatio(row.row.original.profit_ratio || 0);
                  setInvId(row.row.original.inv_id);
                }}
              >
                {lang["Profit_Ratio"] || "Profit Ratio"}
              </button>
            </li>
            <li>
              {row.row.original.status === 1 ? (
                <button
                  className="dropdown-item mt-0"
                  onClick={() => {
                    // Handle deactivate action
                    axios
                      .put(
                        `${apiKey}/change-user-status/investor/${row.row.original.user_id}`,
                        {
                          status: 0,
                        },
                        {
                          headers: {
                            Authorization: `Bearer ${token}`,
                          },
                        }
                      )
                      .then((res) => {
                        fetchInvestor();
                      })
                      .catch((err) => {
                        console.error(err);
                      });
                  }}
                >
                  {lang.Deactivate || "Deactivate"}
                </button>
              ) : (
                <button
                  className="dropdown-item mt-0"
                  onClick={() => {
                    // Handle activate action
                    axios
                      .put(
                        `${apiKey}/change-user-status/investor/${row.row.original.user_id}`,
                        {
                          status: 1,
                        },
                        {
                          headers: {
                            Authorization: `Bearer ${token}`,
                          },
                        }
                      )
                      .then((res) => {
                        fetchInvestor();
                      })
                      .catch((err) => {
                        console.error(err);
                      });
                  }}
                >
                  {lang.Activate || "Activate"}
                </button>
              )}
            </li>
            <li>
              <button
                className="dropdown-item mt-0"
                onClick={() => handleDelete(row.row.original.inv_id)}
              >
                {lang.Delete_Text || "Delete"}
              </button>
            </li>
          </ul>
        </div>
      ),
    },
  ];
  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/delete-single-user/investor/${branchId}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        fetchInvestor();
        toast.success(res.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err.response.data.message || "Some Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const handleProfitUpdate = (e) => {
    e.preventDefault();
    axios
      .put(
        `${apiKey}/investor/profit/${invId}`,
        {
          profit: profitRatio,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        toast.success(res.data.message || "Success");
        fetchInvestor();
      })
      .catch((err) => {
        toast.error(err.response.data.message || "Some error occured");
      });
  };

  useEffect(() => {
    if (branchId) {
      fetchInvestor();
    }
  }, [branchId, fetchInvestor]);
  useEffect(() => {
    setBranchId(
      JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).id
    );
  }, []);
  useEffect(() => {
    if (investorToDelete) {
      try {
        axios
          .put(
            apiKey + "/investor",
            {
              idList: investorToDelete,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((res) => {
            console.log("Success");
            fetchInvestor();
          })
          .catch((err) => {
            console.error("error");
          });
      } catch (err) {
        console.error(err);
      }
    }
  }, [fetchInvestor, investorToDelete, token]);
  return (
    <div>
      <main id="main" className="main">
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div className="pagetitle">
          <h1>
            {lang.Investment_Loan_Management || "Investment/Loan Management"}
          </h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                >
                  <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
                </svg>
              </li>
              <li className="breadcrumb-item">
                {lang.Investment_Loan_Management ||
                  "Investment/Loan Management"}
              </li>
              <li className="breadcrumb-item active">
                {lang.Investor_List || "Investor List"}
              </li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row justify-content-end">
                    <div className="col-md-4 col-lg-3">
                      <Link
                        to={
                          isLighMode ? "add-lightmode-investor" : "add-investor"
                        }
                      >
                        <button
                          type="button"
                          className="btn btn-primary d-flex justify-content-end"
                        >
                          <img
                            src="img/fi_plus.png"
                            alt=""
                            className="img-fluid me-2"
                          />{" "}
                          {lang.Add_New_Investor || "Add New Investor"}
                        </button>
                      </Link>
                    </div>
                  </div>

                  <div className="row pt-3 pb-3">
                    <div className="rr col-9">
                      {lang.Investor_List || "Investor List"}
                    </div>
                  </div>

                  <div classNames="d-flex mt-3 mb-3">
                    <Table
                      lang={lang}
                      data={investorList}
                      columns={columns}
                      returnTable={returnTable}
                      // deleteButton={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="modal fade" id="myModal" tabindex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <form onSubmit={handleProfitUpdate}>
                <div className="row mb-2 d-flex justify-content-center">
                  <div className="col-sm-8  mb-3">
                    <label htmlFor="" className="w-100">
                      <span style={{ fontSize: "14px" }}>
                        {lang["Profit Ratio"] || "Profit Ratio"}
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        value={profitRatio || ""}
                        onChange={(e) => setProfitRatio(e.target.value)}
                        required
                      />
                    </label>
                  </div>
                </div>
                <div className="text-center mb-5">
                  <button
                    type="button"
                    className="btn-save"
                    data-bs-dismiss="modal"
                  >
                    {lang.Cancel || "Cancel"}
                  </button>
                  <button type="submit" className="btn-cancel ms-5">
                    {lang.Add_Now || "Add Now"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const CheckBox = ({ id, status }) => {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [isChecked, setIsChecked] = useState(status === 1);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = () => {
    setIsLoading(true);
    axios
      .put(
        `${apiKey}/investor/makeOffice/${id}`,
        {
          is_office: !isChecked,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setIsChecked(!isChecked);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setIsLoading(false));
  };
  return (
    <input
      type="checkbox"
      checked={isChecked}
      onChange={handleChange}
      disabled={isLoading}
    />
  );
};
